/**
 * O aviso "ResizeObserver loop completed with undelivered notifications"
 * é benigno: acontece quando um callback do ResizeObserver muda o layout
 * (Radix/Recharts/carrosséis) e o navegador adia as notificações para o
 * próximo frame. Ele não quebra nada, mas polui o console e dispara o
 * overlay de erro do Vite. Aqui silenciamos apenas essa mensagem
 * específica e agendamos os callbacks no próximo animation frame para
 * evitar o loop na origem.
 */
const RO_MESSAGE = "ResizeObserver loop";

function isResizeObserverNoise(message?: unknown) {
  return typeof message === "string" && message.includes(RO_MESSAGE);
}

export function installResizeObserverFix() {
  if (typeof window === "undefined") return;

  // 1) Evita o loop: entrega as observações no próximo frame.
  const NativeResizeObserver = window.ResizeObserver;
  if (NativeResizeObserver && !(NativeResizeObserver as any).__patched) {
    class PatchedResizeObserver extends NativeResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        let frame = 0;
        super((entries, observer) => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            frame = 0;
            callback(entries, observer);
          });
        });
      }
    }
    (PatchedResizeObserver as any).__patched = true;
    window.ResizeObserver = PatchedResizeObserver as typeof ResizeObserver;
  }

  // 2) Silencia o aviso residual (inclusive dentro do iframe do editor).
  window.addEventListener(
    "error",
    (event) => {
      if (isResizeObserverNoise(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );

  window.addEventListener("unhandledrejection", (event) => {
    const reason: any = event.reason;
    if (isResizeObserverNoise(reason?.message ?? reason)) {
      event.preventDefault();
    }
  });

  const originalError = console.error;
  console.error = (...args: unknown[]) => {
    if (args.some((a) => isResizeObserverNoise(a) || isResizeObserverNoise((a as any)?.message))) {
      return;
    }
    originalError(...args);
  };
}